import { useMemo } from 'react';
import ActionLink from '../../../../Components/Dashboard/ActionLink';
import API from '../../../../Utils/api';
import useAsync from '../../../../Hooks/useAsync';
import Card from '../../../../Components/Dashboard/Card';
import { CardEmpty, CardError, CardLoading } from '../../../../Components/Dashboard/CardState';
import { weekRange } from '../../../../Utils/dates/localDay';
import { buildWeekPlan } from './weekPlanModel';
import WeekPlanDay from './WeekPlanDay';
import useCoachRoutes from '../useCoachRoutes';
import styles from './WeekPlanCard.module.css';

const TITLE = "This week's plan";

const WeekPlanCard = ({ coachId, now: nowProp }) => {
    const routes = useCoachRoutes();
    const now = useMemo(() => nowProp || new Date(), [nowProp]);
    const { status, data, error, reload } = useAsync(
        () => API.getCoachWeekPlan(coachId, weekRange(now)).then(res => res.data.sessions || []),
        [coachId]
    );

    let body;
    if (status === 'loading' && !data) body = <CardLoading label={TITLE} />;
    else if (status === 'error') body = <CardError label={TITLE} status={error?.response?.status} onRetry={reload} />;
    else if (data && data.length === 0) body = <CardEmpty>No sessions scheduled for this week.</CardEmpty>;
    else if (data) {
        body = (
            <ol className={styles.week}>
                {buildWeekPlan(data, now).map(day => (
                    <WeekPlanDay key={day.key} day={day} />
                ))}
            </ol>
        );
    }

    return (
        <Card
            id="week"
            module="coach-week"
            title={TITLE}
            busy={status === 'loading'}
            flush
            right={<ActionLink to={routes.groups}>Groups calendar</ActionLink>}
        >
            {body}
        </Card>
    );
};

export default WeekPlanCard;
